import { IconDollarComponent } from './IconDollar.styled';

const IconDollar = () => {
  return <IconDollarComponent />;
};

export default IconDollar;
